import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { businessList, belongingToUnit, contractTypeList, params, ...rest } = this.props;
        const { invState } = sessionStorage;
        const { lineOfBusiness } = params;
        const isTotal = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const contractTypeOption = contractTypeList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const belongingToUnitOption = belongingToUnit.map(i => ({ value: i.unitOfBelongingId, label: i.unitOfBelongingName }));
        const filters = [{
            name: '开票时间',
            key: 'invoiceDateStart',
            type: 'monthPicker',
        }, {
            name: '至',
            key: 'invoiceDateEnd',
            type: 'monthPicker',
        }, {
            name: '收款日期',
            key: 'dateInvoiceClosedStart',
            type: 'monthPicker',
        }, {
            name: '至',
            key: 'dateInvoiceClosedEnd',
            type: 'monthPicker',
        }];
        if (!isTotal) {
            filters.push({
                name: 'JDE主项目号',
                key: 'jdeMainCode',
                type: 'input',
            }, {
                name: '项目简称',
                key: 'investigation',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'investigationName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20},
                    url: API_URL.investigation.queryInvestigationByName,
                    config: { id: 'investigationId', name: 'investigationName' }
                }
            }, {
                name: '项目编号',
                key: 'investigationCode',
                type: 'input',
            });
        }
        filters.push({
            name: 'JDE项目号',
            key: 'jdecode',
            type: 'input',
        }, {
            name: '发票号',
            key: 'remark',
            type: 'input',
        }, {
            name: '收入归属单位',
            key: 'belongingToUnit',
            type: 'select',
            typeProperty: {
                style: { width: 120 },
                list: belongingToUnitOption
            }
        }, {
            name: '客户代码',
            key: 'addressNumber',
            type: 'input',
        }, {
            name: '客户名称',
            key: 'customerCompany',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'customerCompanyName',
                style: {width: 160},
                placeholder: '输入客户名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' }
            }
        }, {
            name: '请款单号',
            key: 'invoiceNumber',
            type: 'input',
        }, {
            name: '费用类型',
            key: 'expenseType',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'P', label: 'PT费' },
                    { value: 'S', label: '服务费' },
                ]
            }
        }, {
            name: '过账编辑',
            key: 'postingEdit',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'N', label: 'N' },
                    { value: 'empty', label: '为空' },
                ]
            }
        });
        if (!isTotal) {
            filters.push({
                name: '业务线',
                key: 'lineOfBusiness',
                type: 'select',
                typeProperty: {
                    list: businessOption,
                }
            }, {
                name: '执行业务线二级分类',
                key: 'secondLineName',
                type: 'select',
                typeProperty: {
                    disabled: !lineOfBusiness,
                    list: secondLineOption,
                }
            });
        }
        filters.push({
            name: '计收入确认方式',
            key: 'contractTypeId',
            type: 'select',
            typeProperty: {
                list: contractTypeOption,
            }
        }, {
            name: 'PM',
            key: 'pm',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '领域leader',
            key: 'tal',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '预收未开票',
            key: 'isAdvanceCollectedNotInvoiced',
            type: 'select',
            typeProperty: {
                list: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' },
                ]
            }
        },{
            name: '总账冲销',
            key: 'gloffSet',
            type: 'input',
        },{
            name: '收款号',
            key: 'receiptNumber',
            type: 'input',
        }, {
            name: '支付状态',
            key: 'payStatus',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'P', label: 'P' },
                    { value: 'A', label: 'A' },
                ]
            }
        }, {
            name: '是否超账期',
            key: 'overduePeriodFlag',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' },
                ]
            }
        });
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/returnedMoney/Filter.js